export default {
  init() {
    // JavaScript to be fired on the about us page
    var $scrollTo = $('.scroll-to')
    if($scrollTo.length){
		var offset = $('.scroll-to').first().offset().top - 100;
		$('html, body').animate({ scrollTop: offset }, 1000);
	}
  },
};


document.addEventListener('DOMContentLoaded', function () {
  // Get all buttons with the class 'social'
  var socialButtons = document.querySelectorAll('.social');
  var socialPopups = document.querySelectorAll('.social-popup');

  // Add click event listener to each button
  socialButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      // Get the value of the data-social-popup attribute
      var socialPopupId = button.getAttribute('data-social-popup');

      // Get the social popup element by ID
      var socialPopup = document.getElementById(socialPopupId);

      // Toggle the 'open' class on the social popup element
      socialPopup.classList.add('open');
    });
  });

  socialPopups.forEach(function (popup) {
    var closeButton = document.querySelector('.close-popup');
    closeButton.addEventListener('click', function () {

      popup.classList.remove('open');
    });
  });
});


// WEBPACK FOOTER //
// ./scripts/routes/page.js